import PropTypes from "prop-types";
import React, { useState } from "react";

import { TOOLTIP_OFFSET } from "src/Components/Tooltips/utils";
import { Tooltip } from "reactstrap";

export default function TooltipWrapper({ content, placement, id, children }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen((prevState) => !prevState);
  const validId = id.replace(/[/:]/g, "");
  return (
    <>
      <span id={validId}>{children}</span>
      <Tooltip
        target={validId}
        placement={placement}
        isOpen={tooltipOpen}
        toggle={toggle}
        innerClassName="tooltip-max-width"
        offset={TOOLTIP_OFFSET}
        popperClassName="tooltip-help"
      >
        {content}
      </Tooltip>
    </>
  );
}

TooltipWrapper.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
};

TooltipWrapper.defaultProps = {
  placement: "auto",
};
